import graphql__b6f78a9eff1876c669dc from "./__generated__/CompleteOralInterviewMutation.graphql.js";import { commitMutation, graphql } from "react-relay";

import appRelayEnvironment from "../config/AppRelayEnvironment";

const mutation = graphql__b6f78a9eff1876c669dc;

const completeOralInterview = (
  variables,
  onCompleted,
  onError = error => console.error(error)
) =>
  commitMutation(appRelayEnvironment, {
    mutation,
    variables,
    onCompleted,
    onError
  });

export { completeOralInterview };
